import { checkHostnames, isEmpty } from '@sigma-frontend-libs/commons'
import { ETTSTypes } from '@sigmasms/shared-types'

import { imlinkHostnames, proxy } from '@/utils'

import render from './render'

export default {
  name: 'TTS',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    ttsFile: {
      type: Object,
      default: undefined
    },

    ttsCooldown: {
      type: Number,
      default: 0
    },

    disabled: {
      type: Boolean,
      default: undefined
    }
  },

  computed: {
    validation() {
      return !isEmpty(this.proxy.text) && !isEmpty(this.proxy.tts)
    },

    generateDisabled() {
      return this.loading || this.disabled || !this.validation
    },

    ttsTypes() {
      const result = []
      const isImlink = checkHostnames(imlinkHostnames)
      for (const value of Object.values(ETTSTypes)) {
        if (isImlink && !value.startsWith('aws:')) {
          continue
        }

        const [ company ] = value.split(':')
        const title = [
          this.getTranslate(`sendingsCreate.voice.company.${company}`),
          this.getTranslate(`sendingsCreate.voice.names.${value}`)
        ].join(' - ')

        result.push({
          title,
          value
        })
      }

      return result
    },

    buttonLabel() {
      let result = 'generate'
      if (!isEmpty(this.ttsFile)) {
        result = 'regenerate'
      }

      return this.getTranslate(`buttons.tts.${result}`)
    }
  },

  methods: {
    generateHandler() {
      if (!this.loading && !this.disabled) {
        this.$emit('generate')
      }
    },

    clearHandler() {
      this.$emit('clear', { type: 'audio' })
    }
  },

  render
}
